import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export const Rentals = () => {
  return (
    <div className="page">
      <Typography gutterBottom variant="h3" align="center">
        Rentals
      </Typography>

      <Typography
        gutterBottom
        sx={{ backgroundColor: "#ffee90", p: 2, mx: "0.7%" }}
      >
        Rentals are only available during store hours. No sunrise or sunset rentals, sorry! 
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">Rental</TableCell>
              <TableCell align="center">1 Hr</TableCell>
              <TableCell align="center">4 Hrs</TableCell>
              <TableCell align="center">1 Day</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell align="center">Canoe</TableCell>
              <TableCell align="center">$15.00</TableCell>
              <TableCell align="center">$30.00</TableCell>
              <TableCell align="center">$45.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center">Kayak</TableCell>
              <TableCell align="center">$15.00</TableCell>
              <TableCell align="center">$30.00</TableCell>
              <TableCell align="center">$45.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center">Tandem Kayak</TableCell>
              <TableCell align="center">$24.00</TableCell>
              <TableCell align="center">$45.00</TableCell>
              <TableCell align="center">$60.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center">Kid's Kayak</TableCell>
              <TableCell align="center">$10.00</TableCell>
              <TableCell align="center">$20.00</TableCell>
              <TableCell align="center">$30.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center">Paddleboard</TableCell>
              <TableCell align="center">$15.00</TableCell>
              <TableCell align="center">$30.00</TableCell>
              <TableCell align="center">$45.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center">Paddleboat</TableCell>
              <TableCell align="center">$15.00</TableCell>
              <TableCell align="center">$30.00</TableCell>
              <TableCell align="center">$45.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center">Bicycle</TableCell>
              <TableCell align="center">$5.00</TableCell>
              <TableCell align="center">$10.00</TableCell>
              <TableCell align="center">$15.00</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Typography
        gutterBottom
        sx={{ backgroundColor: "#a8d5e5", p: 2, mx: "0.7%" }}
      >
        All prices are subject to HST
      </Typography>
    </div>
  );
};
